(function () {
  "use strict";

  const SCRIPT_SRC =
    (document.currentScript && document.currentScript.src) || "";
  // ── Constants ──────────────────────────────────────────────
  const FOOTER_SEL = ".gbbPageFooterHTML, .gbbAddProductsPageFooterHTML";
  const BUTTONS_SEL = ".gbbFooterButtonsWrapper, .gbbFooterButtonsContainer";

  // ── Helpers ────────────────────────────────────────────────
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => root.querySelectorAll(sel);

  function getFooter() {
    return $(FOOTER_SEL);
  }

  function getTotalSteps() {
    try {
      const cond =
        window.tmpCartSettings2?.stepsConfigurationData?.productsData1
          ?.conditions?.[0];
      if (cond?.type === "quantity") return parseInt(cond.value, 10) || 4;
    } catch (_) {}
    return 4;
  }

  function stripDecimals(el) {
    if (el && el.textContent.includes(".00"))
      el.textContent = el.textContent.replace(".00", "");
  }

  // ── Stepper HTML ───────────────────────────────────────────
  function generateStepperHTML(totalSteps) {
    const steps = Array.from({ length: totalSteps }, (_, i) => {
      const n = i + 1;
      return `
        <div class="bundle-app-new-step" id="bundle-app-new-step-${n}">
          <div class="bundle-app-new-step-box">${n}</div>
          <div class="bundle-app-new-step-label">Select your</div>
          <div class="bundle-app-new-step-sublabel">Item ${n}</div>
        </div>
        ${n < totalSteps ? '<div class="bundle-app-new-connector"></div>' : ""}`;
    }).join("");

    return `
      <div id="bundle-app-new-stepper-root" class="bundle-app-new-stepper-container" data-total-steps="${totalSteps}">
        <div class="bundle-app-new-spacer"></div>
        ${steps}
        <div class="bundle-app-new-spacer"></div>
        <div class="bundle-app-new-arrow-icon">
          <svg width="30" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>`;
  }

  // ── Stepper inject ─────────────────────────────────────────
  function injectStepper(footer, totalSteps) {
    if ($("#bundle-app-new-stepper-root")) return;

    const buttonsWrapper = $(BUTTONS_SEL, footer);
    const innerContainer =
      Array.from(footer.children).find((c) => c.tagName === "DIV") || footer;

    const tmp = document.createElement("div");
    tmp.innerHTML = generateStepperHTML(totalSteps);
    const stepper = tmp.firstElementChild;

    if (buttonsWrapper?.parentElement) {
      buttonsWrapper.parentElement.insertBefore(stepper, buttonsWrapper);
    } else {
      innerContainer.appendChild(stepper);
    }

    const parent = stepper.parentElement;
    if (parent)
      Object.assign(parent.style, {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      });

    // Ensure the stepper itself uses flex-start to align connectors with boxes
    Object.assign(stepper.style, {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
    });
  }

  // ── Sync stepper state ─────────────────────────────────────
  function syncStepperState() {
    if (window.bundleAppSyncing) return;
    window.bundleAppSyncing = true;

    try {
      const footer = getFooter();
      if (!footer) return;

      const totalSteps = getTotalSteps();
      const existingRoot = $("#bundle-app-new-stepper-root");

      if (existingRoot) {
        if (parseInt(existingRoot.dataset.totalSteps || 0) !== totalSteps) {
          existingRoot.remove();
          injectStepper(footer, totalSteps);
          return;
        }
      } else {
        injectStepper(footer, totalSteps);
      }

      // Build filled slots from footer products
      const filledSlots = [];
      $$(".gbbFooterProductContainer", footer).forEach((product, index) => {
        const qtyText =
          $(".gbbFooterProductQuantity", product)?.innerText?.trim() ?? "x1";
        const qty = parseInt(qtyText.match(/x?(\d+)/)?.[1] ?? 1, 10);
        const imgSrc = $(".gbbFooterProductImage", product)?.src ?? "";
        for (let k = 0; k < qty; k++)
          filledSlots.push({ productIndex: index, img: imgSrc });
      });

      // Update each step
      for (let i = 0; i < totalSteps; i++) {
        const stepNode = $(`#bundle-app-new-step-${i + 1}`);
        if (!stepNode) continue;

        const stepBox = $(".bundle-app-new-step-box", stepNode);
        const slotData = filledSlots[i];

        if (slotData) {
          if (!stepNode.classList.contains("filled")) {
            stepNode.classList.remove("active");
            stepNode.classList.add("filled");
            stepBox.innerHTML = `
              <img src="${slotData.img}" class="bundle-app-new-step-img" alt="Selected Product">
              <div class="bundle-app-new-step-close" data-product-index="${slotData.productIndex}">✕</div>`;
          } else {
            const img = $("img", stepBox);
            if (img && img.src !== slotData.img) img.src = slotData.img;
            const btn = $(".bundle-app-new-step-close", stepBox);
            if (btn) btn.dataset.productIndex = slotData.productIndex;
          }
        } else {
          if (stepNode.classList.contains("filled")) {
            stepNode.classList.remove("filled");
            stepBox.innerHTML = `${i + 1}`;
          }
          stepNode.classList.toggle("active", i === filledSlots.length);
        }
      }

      // Button state
      const nextBtn = $(".gbbFooterNextButton");
      if (nextBtn) {
        clearButtonText(nextBtn);
        const complete = filledSlots.length === totalSteps;
        nextBtn.classList.toggle("bundle-app-disabled-btn", !complete);
        nextBtn.disabled = !complete;
      }

      showcasePrices(footer);
    } finally {
      window.bundleAppSyncing = false;
    }
  }

  // ── Clear "Next" text from button ──────────────────────────
  function clearButtonText(btn) {
    const nextBtn = btn || $(".gbbFooterNextButton");
    if (!nextBtn) return;
    const text = (nextBtn.textContent || "").trim().toUpperCase();
    if (text && !text.includes("ADD TO CART")) nextBtn.textContent = "";
    Array.from(nextBtn.childNodes).forEach((node) => {
      if (node.nodeType === 3 && node.textContent.trim()) node.textContent = "";
    });
  }

  // ── Discount tags ──────────────────────────────────────────
  function injectDiscountTags() {
    $$(
      ".gbbProductItemPricesContainer, .gbbProductVariantModalMainContainer",
    ).forEach((container) => {
      if ($(".gbbProductDiscountTag", container)) return;

      const priceEl = $(".gbbProductItemPrice", container);
      const compareEl = $(".gbbProductItemCompareAtPrice", container);
      if (!priceEl || !compareEl) return;

      stripDecimals(priceEl);
      stripDecimals(compareEl);

      const price = parseFloat(priceEl.textContent.replace(/[^\d.]/g, ""));
      const compare = parseFloat(compareEl.textContent.replace(/[^\d.]/g, ""));
      if (isNaN(price) || isNaN(compare) || compare <= price) return;

      const discount = Math.round(((compare - price) / compare) * 100);
      if (discount <= 0) return;

      const tag = document.createElement("span");
      tag.className = "gbbProductDiscountTag";
      tag.textContent = `(${discount}% OFF)`;
      compareEl.after(tag);
    });
  }

  // ── Select → tabs ──────────────────────────────────────────
  function convertSelectToTabs() {
    const banners = window.bundleBannerData || {};
    if (!banners.show_different_tabs) return;

    const wrapper = $(".gbbAddGiftBoxPageWrapper, .gbbProductsItemsContainer");
    if (!wrapper) return;

    $$("select", wrapper).forEach((select) => {
      if (select.dataset.tabsInitialized) return;
      select.style.display = "none";
      select.dataset.tabsInitialized = "true";

      $$("svg", select.parentNode).forEach(
        (svg) => (svg.style.display = "none"),
      );

      const tabsContainer = document.createElement("div");
      tabsContainer.className = "bundle-custom-tabs-container";

      Array.from(select.options).forEach((option) => {
        const cleanText = option.text
          .replace(/[\u25BC\u25B2\u2304\u2303▼▲⌄⌃˅^]/g, "")
          .trim();
        if (!cleanText) return;

        const tab = document.createElement("button");
        tab.className =
          "bundle-custom-tab" + (option.selected ? " active" : "");
        tab.textContent = cleanText;

        tab.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          $$(".bundle-custom-tab", tabsContainer).forEach((t) =>
            t.classList.remove("active"),
          );
          tab.classList.add("active");
          select.value = option.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        });

        tabsContainer.appendChild(tab);
      });

      select.before(tabsContainer);
    });
  }
  // ── Size chart metaobject──────────────────────────────────────────────
  // function injectSizeChart() {
  //   const modal = $(".gbbProductVariantModalMainContainer");

  //   if (!modal) return;

  //   // Already injected into this modal
  //   if ($(".bundle-size-chart-link", modal)) return;

  //   const titleEl = $(".gbbProductItemTitle", modal);

  //   if (!titleEl) return;

  //   const productTitle = titleEl.textContent
  //     .replace(/\s+/g, " ")
  //     .trim()
  //     .toLowerCase();

  //   let chartUrl = "";

  //   const sizeCharts = window.bundleSizeChartMetaobjects || [];

  //   if (sizeCharts.length > 0) {
  //     let productId = "";

  //     const productIdSelectors = [
  //       "[data-product-id]",
  //       "[productid]",
  //       "[data-productid]",
  //     ];

  //     for (const selector of productIdSelectors) {
  //       const el = modal.querySelector(selector);

  //       if (!el) continue;

  //       productId =
  //         el.getAttribute("data-product-id") ||
  //         el.getAttribute("productid") ||
  //         el.getAttribute("data-productid") ||
  //         "";

  //       if (productId) break;
  //     }
  //     if (productId) {
  //       const matchedChart = sizeCharts.find(
  //         (chart) => String(chart.productId) === String(productId),
  //       );

  //       if (matchedChart) {
  //         chartUrl = matchedChart.image;
  //       }
  //     }

  //     if (!chartUrl && productTitle) {
  //       const matchedChart = sizeCharts.find((chart) => {
  //         const chartProductTitle = String(chart.productTitle || "")
  //           .replace(/\s+/g, " ")
  //           .trim()
  //           .toLowerCase();

  //         return chartProductTitle === productTitle;
  //       });

  //       if (matchedChart) {
  //         chartUrl = matchedChart.image;
  //       }
  //     }
  //   }

  //   if (!chartUrl && window.bundlePageSizeCharts) {
  //     const titleText = productTitle;

  //     const allTabs = $$("button, a, span, div, .eb-category-item");

  //     let activeCategory = "";
  //     let foundAnyTab = false;

  //     for (const el of allTabs) {
  //       const txt = el.textContent.toLowerCase().trim();

  //       if (txt !== "men" && txt !== "women") continue;

  //       foundAnyTab = true;

  //       const isActive =
  //         el.classList.contains("active") ||
  //         el.classList.contains("selected") ||
  //         el.parentElement?.classList.contains("active") ||
  //         el.parentElement?.classList.contains("selected") ||
  //         el.getAttribute("aria-selected") === "true";

  //       if (isActive) {
  //         activeCategory = txt;
  //         break;
  //       }
  //     }

  //     if (!foundAnyTab) {
  //       chartUrl = window.bundlePageSizeCharts.men || "";
  //     } else if (activeCategory === "women" || titleText.includes("women")) {
  //       chartUrl = window.bundlePageSizeCharts.women || "";
  //     } else if (activeCategory === "men" || titleText.includes("men")) {
  //       chartUrl = window.bundlePageSizeCharts.men || "";
  //     }
  //   }
  //   if (
  //     !chartUrl ||
  //     chartUrl.includes("no-image") ||
  //     chartUrl.includes("undefined")
  //   ) {
  //     console.log("[Size Chart] No size chart found for:", productTitle);

  //     return;
  //   }
  //   const link = document.createElement("a");

  //   link.className = "bundle-size-chart-link";
  //   link.textContent = "Size Chart";

  //   link.addEventListener("click", (e) => {
  //     e.preventDefault();
  //     e.stopPropagation();

  //     showSizeChartModal(chartUrl);
  //   });
  //   const sizeLabel = $(
  //     '.gbbProductVariantOptionContainer[optionid="Size"] .gbbProductVariantOptionLabelContainer',
  //     modal,
  //   );

  //   if (sizeLabel) {
  //     Object.assign(sizeLabel.style, {
  //       display: "flex",
  //       justifyContent: "space-between",
  //       alignItems: "center",
  //     });

  //     sizeLabel.appendChild(link);
  //   } else {
  //     const anchor = $(".gbbProductItemPricesContainer", modal) || titleEl;

  //     anchor.after(link);
  //   }

  //   console.log("[Size Chart] Loaded:", chartUrl, "for product:", productTitle);
  // }
  // ── Size chart (CSV from theme assets: size_chart-metaobjects.csv) ──────────
  const normKey = (s) =>
    String(s || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  const slugify = (s) =>
    String(s || "")
      .toLowerCase()
      .replace(/['’]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  function getSizeChartCsvUrl() {
    if (window.bundleSizeChartCsvUrl) return window.bundleSizeChartCsvUrl;

    const candidates = [];
    if (SCRIPT_SRC) candidates.push(SCRIPT_SRC);
    document
      .querySelectorAll('link[href*="/assets/"], script[src*="/assets/"]')
      .forEach((el) => candidates.push(el.href || el.src));

    for (const u of candidates) {
      if (
        /\/assets\/[^/?]+/.test(u) &&
        (u.indexOf(location.host) > -1 || u.indexOf("cdn.shopify.com") > -1)
      ) {
        return u.replace(
          /\/assets\/[^?]*/,
          "/assets/size_chart-metaobjects.csv",
        );
      }
    }
    return "";
  }

  function parseCsv(text) {
    const rows = [];
    let row = [];
    let cur = "";
    let inQuotes = false;
    text = text.replace(/^\uFEFF/, "");

    for (let i = 0; i < text.length; i++) {
      const ch = text[i];
      if (inQuotes) {
        if (ch === '"' && text[i + 1] === '"') {
          cur += '"';
          i++;
        } else if (ch === '"') {
          inQuotes = false;
        } else {
          cur += ch;
        }
      } else if (ch === '"') {
        inQuotes = true;
      } else if (ch === ",") {
        row.push(cur);
        cur = "";
      } else if (ch === "\n" || ch === "\r") {
        if (ch === "\r" && text[i + 1] === "\n") i++;
        row.push(cur);
        cur = "";
        if (row.some((c) => c.trim() !== "")) rows.push(row);
        row = [];
      } else {
        cur += ch;
      }
    }
    row.push(cur);
    if (row.some((c) => c.trim() !== "")) rows.push(row);
    return rows;
  }

  // Builds { byHandle, byNorm, byId } lookups from the CSV
  function loadSizeChartCsv() {
    if (window.bundleSizeChartCsvPromise)
      return window.bundleSizeChartCsvPromise;

    const url = getSizeChartCsvUrl();
    const empty = () => ({ byHandle: {}, byNorm: {}, byId: {} });

    window.bundleSizeChartCsvPromise = (
      url
        ? fetch(url)
            .then((r) => {
              if (!r.ok) throw new Error("HTTP " + r.status + " for " + url);
              return r.text();
            })
            .then((text) => {
              const maps = empty();
              const rows = parseCsv(text);
              if (rows.length < 2) return maps;

              const headers = rows[0].map((h) => h.trim().toLowerCase());
              const findCol = (name) =>
                headers.findIndex(
                  (h) =>
                    h === name ||
                    h.endsWith("." + name) ||
                    h.endsWith(" " + name),
                );
              const imageIdx = findCol("image");
              const productsIdx = findCol("products");
              if (imageIdx === -1 || productsIdx === -1) {
                console.error(
                  "[Size Chart] Missing image/products column. Headers:",
                  headers,
                );
                return maps;
              }

              for (let i = 1; i < rows.length; i++) {
                const image = (rows[i][imageIdx] || "").trim();
                if (!image) continue;

                (rows[i][productsIdx] || "")
                  .replace(/[\[\]"']/g, "")
                  .split(/[,;|]/)
                  .map((t) => t.trim().toLowerCase())
                  .filter(Boolean)
                  .forEach((t) => {
                    const gid = t.match(/product\/(\d+)/);
                    const urlHandle = t.match(/\/products\/([^/?#]+)/);
                    if (gid) {
                      maps.byId[gid[1]] = image;
                    } else if (/^\d{6,}$/.test(t)) {
                      maps.byId[t] = image;
                    } else {
                      const h = urlHandle ? urlHandle[1] : t;
                      maps.byHandle[h] = image;
                      maps.byNorm[normKey(h)] = image;
                    }
                  });
              }
              console.log(
                "[Size Chart] CSV loaded:",
                url,
                Object.keys(maps.byHandle).length + " handles,",
                Object.keys(maps.byId).length + " ids",
              );
              return maps;
            })
        : Promise.reject(new Error("CSV URL could not be determined"))
    )
      .catch((err) => {
        console.error("[Size Chart] CSV lookup failed:", err);
        return empty();
      })
      .then((maps) => {
        window.bundleSizeChartCsvMap = maps;
        return maps;
      });

    return window.bundleSizeChartCsvPromise;
  }

  function getModalProductId(modal) {
    for (const sel of [
      "[data-product-id]",
      "[productid]",
      "[data-productid]",
    ]) {
      const el = modal.matches(sel) ? modal : modal.querySelector(sel);
      if (!el) continue;
      const v =
        el.getAttribute("data-product-id") ||
        el.getAttribute("productid") ||
        el.getAttribute("data-productid") ||
        "";
      const m = String(v).match(/(\d+)\s*$/);
      if (m) return m[1];
    }
    return "";
  }

  function getModalProductHandles(modal, productTitle) {
    const out = [];
    const add = (h) => {
      h = String(h || "")
        .trim()
        .toLowerCase();
      if (h && out.indexOf(h) === -1) out.push(h);
    };

    modal.querySelectorAll('a[href*="/products/"]').forEach((a) => {
      const m = (a.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
      if (m) add(decodeURIComponent(m[1]));
    });
    modal
      .querySelectorAll("[data-product-handle],[producthandle],[data-handle]")
      .forEach((el) =>
        add(
          el.getAttribute("data-product-handle") ||
            el.getAttribute("producthandle") ||
            el.getAttribute("data-handle"),
        ),
      );
    add(slugify(productTitle));
    return out;
  }

  // Last resort: ask Shopify's predictive search for the real handle by title
  function resolveHandleByTitle(title) {
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    const url =
      root +
      "search/suggest.json?q=" +
      encodeURIComponent(title) +
      "&resources[type]=product&resources[limit]=5&resources[options][fields]=title";

    return fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        const list =
          (d &&
            d.resources &&
            d.resources.results &&
            d.resources.results.products) ||
          [];
        const t = normKey(title);
        const hit = list.find((p) => normKey(p.title) === t);
        return hit ? hit.handle : "";
      })
      .catch(() => "");
  }

  function findChartInCsv(maps, modal, productTitle) {
    const id = getModalProductId(modal);
    if (id && maps.byId[id]) return maps.byId[id];

    const handles = getModalProductHandles(modal, productTitle);
    for (const h of handles) {
      if (maps.byHandle[h]) return maps.byHandle[h];
      if (maps.byNorm[normKey(h)]) return maps.byNorm[normKey(h)];
    }

    const titleNorm = normKey(productTitle);
    if (maps.byNorm[titleNorm]) return maps.byNorm[titleNorm];

    // Loose match, accepted only if exactly one CSV entry fits
    if (titleNorm.length >= 6) {
      const hits = Object.keys(maps.byNorm).filter(
        (k) =>
          k.length >= 6 && (k.startsWith(titleNorm) || titleNorm.startsWith(k)),
      );
      if (hits.length === 1) return maps.byNorm[hits[0]];
    }
    return "";
  }

  function injectSizeChart() {
    const modal = $(".gbbProductVariantModalMainContainer");
    if (!modal) return;

    const titleEl = $(".gbbProductItemTitle", modal);
    if (!titleEl) return;

    const productTitle = titleEl.textContent
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
    if (!productTitle) return;

    // Existing link: keep it if it is for this product, otherwise remove (modal reused)
    const existing = $(".bundle-size-chart-link", modal);
    if (existing) {
      if (existing.dataset.chartFor === productTitle) return;
      existing.remove();
    }

    // CSV not loaded yet -> load once, then re-run
    if (!window.bundleSizeChartCsvMap) {
      loadSizeChartCsv().then(() => injectSizeChart());
      return;
    }

    const maps = window.bundleSizeChartCsvMap;
    let chartUrl = findChartInCsv(maps, modal, productTitle);

    // 1b) Resolve the real handle by title, then retry the CSV
    if (!chartUrl) {
      const cache = (window.bundleResolvedHandles =
        window.bundleResolvedHandles || {});
      const key = normKey(productTitle);

      if (!(key in cache)) {
        cache[key] = null; // in flight
        resolveHandleByTitle(productTitle).then((h) => {
          cache[key] = h || "";
          injectSizeChart();
        });
        return;
      }
      if (cache[key] === null) return; // still waiting

      if (cache[key]) {
        chartUrl =
          maps.byHandle[cache[key].toLowerCase()] ||
          maps.byNorm[normKey(cache[key])] ||
          "";
      }
    }

    // 2) Legacy metaobject array (fallback)
    const sizeCharts = window.bundleSizeChartMetaobjects || [];
    if (!chartUrl && sizeCharts.length > 0) {
      const productId = getModalProductId(modal);
      const idOf = (v) => (String(v || "").match(/(\d+)\s*$/) || [])[1] || "";

      if (productId) {
        const m = sizeCharts.find((c) => idOf(c.productId) === productId);
        if (m) chartUrl = m.image;
      }
      if (!chartUrl) {
        const m = sizeCharts.find(
          (c) =>
            String(c.productTitle || "")
              .replace(/\s+/g, " ")
              .trim()
              .toLowerCase() === productTitle,
        );
        if (m) chartUrl = m.image;
      }
    }

    // 3) Page-level Men / Women default charts
    if (!chartUrl && window.bundlePageSizeCharts) {
      const allTabs = $$("button, a, span, div, .eb-category-item");
      let activeCategory = "";
      let foundAnyTab = false;

      for (const el of allTabs) {
        const txt = el.textContent.toLowerCase().trim();
        if (txt !== "men" && txt !== "women") continue;
        foundAnyTab = true;

        const isActive =
          el.classList.contains("active") ||
          el.classList.contains("selected") ||
          el.parentElement?.classList.contains("active") ||
          el.parentElement?.classList.contains("selected") ||
          el.getAttribute("aria-selected") === "true";

        if (isActive) {
          activeCategory = txt;
          break;
        }
      }

      if (!foundAnyTab) {
        chartUrl = window.bundlePageSizeCharts.men || "";
      } else if (activeCategory === "women" || productTitle.includes("women")) {
        chartUrl = window.bundlePageSizeCharts.women || "";
      } else if (activeCategory === "men" || productTitle.includes("men")) {
        chartUrl = window.bundlePageSizeCharts.men || "";
      }
    }

    if (
      !chartUrl ||
      chartUrl.includes("no-image") ||
      chartUrl.includes("undefined")
    ) {
      console.log("[Size Chart] No size chart found for:", productTitle, {
        id: getModalProductId(modal),
        handlesTried: getModalProductHandles(modal, productTitle),
      });
      return;
    }

    const link = document.createElement("a");
    link.className = "bundle-size-chart-link";
    link.dataset.chartFor = productTitle;
    link.textContent = "Size Chart";

    link.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      showSizeChartModal(chartUrl);
    });

    const sizeLabel = $(
      '.gbbProductVariantOptionContainer[optionid="Size"] .gbbProductVariantOptionLabelContainer',
      modal,
    );

    if (sizeLabel) {
      Object.assign(sizeLabel.style, {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      });
      sizeLabel.appendChild(link);
    } else {
      const anchor = $(".gbbProductItemPricesContainer", modal) || titleEl;
      anchor.after(link);
    }

    console.log("[Size Chart] Loaded:", chartUrl, "for product:", productTitle);
  }

  function showSizeChartModal(url) {
    let modal = $("#bundle-size-chart-popup");
    if (!modal) {
      modal = document.createElement("div");
      modal.id = "bundle-size-chart-popup";
      modal.className = "bundle-size-chart-modal";
      modal.innerHTML = `
        <div class="bundle-size-chart-content">
          <span class="bundle-size-chart-close">&times;</span>
          <img class="bundle-size-chart-img" src="" alt="Size Chart">
        </div>`;
      document.body.appendChild(modal);
      $(".bundle-size-chart-close", modal).addEventListener(
        "click",
        () => (modal.style.display = "none"),
      );
      modal.addEventListener("click", (e) => {
        if (e.target === modal) modal.style.display = "none";
      });
    }
    $(".bundle-size-chart-img", modal).src = url;
    modal.style.display = "flex";
  }

  // ── Prices in footer ───────────────────────────────────────
  function showcasePrices(footer) {
    if (!footer || window.bundleAppShowcasingPrices) return;
    window.bundleAppShowcasingPrices = true;

    try {
      clearButtonText();

      const totalContainer = $(".gbbFooterTotalContainer", footer);
      if (!totalContainer) return;

      const totalLabel = $(".gbbFooterTotalLabel", totalContainer);
      if (totalLabel) totalLabel.style.display = "none";

      Object.assign(totalContainer.style, {
        display: "flex",
        visibility: "visible",
      });

      const origEl = $(".gbbFooterOriginalTotalValue", totalContainer);
      const discEl = $(".gbbFooterDiscountedTotalValue", totalContainer);
      const valContainer = $(".gbbFooterTotalValueContainer", totalContainer);

      [origEl, discEl].forEach((el) => {
        if (!el) return;
        stripDecimals(el);
        Object.assign(el.style, { display: "block", visibility: "visible" });
      });

      if (valContainer)
        Object.assign(valContainer.style, {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          visibility: "visible",
        });

      const buttonsWrapper = $(BUTTONS_SEL, footer);
      if (buttonsWrapper && totalContainer.parentElement !== buttonsWrapper) {
        const nextBtn = $(".gbbFooterNextButton", buttonsWrapper);
        let referenceNode = nextBtn;
        while (referenceNode && referenceNode.parentNode !== buttonsWrapper) {
          referenceNode = referenceNode.parentNode;
        }
        buttonsWrapper.insertBefore(
          totalContainer,
          referenceNode || buttonsWrapper.firstChild,
        );
      }
    } finally {
      setTimeout(() => {
        window.bundleAppShowcasingPrices = false;
      }, 100);
    }
  }

  // ── Click delegation ───────────────────────────────────────
  function handleStepperClick(e) {
    if (!e.target.classList.contains("bundle-app-new-step-close")) return;

    const index = parseInt(e.target.dataset.productIndex, 10);
    const footer = getFooter();
    if (!footer) return;

    const product = $$(".gbbFooterProductContainer", footer)[index];
    const removeBtn = product && $(".gbbFooterProductRemoveButton", product);
    if (removeBtn) removeBtn.click();
  }

  // ── Sticky footer ──────────────────────────────────────────
  function initStickyFooter() {
    const footers = $$(FOOTER_SEL);
    if (footers.length === 0) return;

    // If multiple footers exist, prefer the one NOT in body (freshly rendered by app)
    const freshFooter = Array.from(footers).find(
      (f) => f.parentElement !== document.body,
    );
    const footer = freshFooter || footers[0];

    // Clean up any other duplicate footers already in body
    Array.from(footers).forEach((f) => {
      if (f !== footer && f.parentElement === document.body) f.remove();
    });

    if (footer.parentElement !== document.body)
      document.body.appendChild(footer);

    const styles = {
      position: "fixed",
      bottom: "0",
      left: "0",
      right: "0",
      width: "100%",
      zIndex: "2",
      background: "white",
      boxShadow: "0 -4px 20px rgba(0,0,0,0.15)",
      padding: "15px 20px",
      boxSizing: "border-box",
      display: "block",
      visibility: "visible",
      opacity: "1",
    };
    Object.entries(styles).forEach(([k, v]) =>
      footer.style.setProperty(k, v, "important"),
    );

    const innerDiv = Array.from(footer.children).find(
      (c) => c.tagName === "DIV",
    );
    if (innerDiv) {
      const cw =
        getComputedStyle(document.documentElement).getPropertyValue(
          "--container-width",
        ) || "1280px";
      Object.entries({
        maxWidth: cw,
        margin: "0 auto",
        width: "100%",
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center",
        justifyContent: "space-between",
      }).forEach(([k, v]) => innerDiv.style.setProperty(k, v, "important"));
    }

    const updatePadding = () => {
      document.body.style.paddingBottom = footer.offsetHeight + "px";
    };

    if (!window.gbbStickyListenerAttached) {
      window.addEventListener("resize", updatePadding, { passive: true });
      window.gbbStickyListenerAttached = true;
    }

    updatePadding();
    setTimeout(updatePadding, 100);
    setTimeout(updatePadding, 500);
  }

  function injectCustomBundleBanners() {
    function tryInject() {
      const banners = window.bundleBannerData || {};
      const defaultBanner = document.querySelector(".gbbAddProductPageBanners");
      const subtext = document.querySelector(".gbbAddProductPageSubtext");

      if (!banners.show_different_banners) {
        if (defaultBanner) {
          defaultBanner.style.display = "";
        }
        if (subtext) {
          subtext.style.display = "";
        }
        const existing = document.querySelector(".bundle-custom-banners");
        if (existing) {
          existing.remove();
        }
        document.body.classList.remove("bundle-custom-banners-active");

        const ribbon = document.querySelector(
          ".gbbMultipleCategoriesRibbonContainer",
        );
        const dropdown = document.querySelector(
          ".gbbMultipleCategoriesDropdownContainer",
        );
        if (ribbon) {
          if (banners.show_different_tabs) {
            ribbon.style.setProperty("display", "none", "important");
          } else {
            ribbon.style.setProperty("display", "", "");
          }
        }
        if (dropdown) {
          if (banners.show_different_tabs) {
            dropdown.style.setProperty("display", "none", "important");
          } else {
            dropdown.style.setProperty("display", "", "");
          }
        }
        return true;
      }

      if (subtext) {
        subtext.style.display = "none";
      }

      if (!banners.desktop1 && !banners.desktop2) return false;

      if (!defaultBanner) return false;

      // Remove existing banners before re-injecting (handles app re-renders)
      const existing = document.querySelector(".bundle-custom-banners");
      if (existing) {
        // Verify it's still in the right place
        if (existing.nextElementSibling === defaultBanner) return true;
        // If not in the right place, remove and re-inject
        existing.remove();
      }

      const html = `
        <div class="bundle-custom-banners">

          ${
            banners.desktop1
              ? `
            <picture class="bundle-custom-banner">
              <source
                media="(max-width:989px)"
                srcset="${banners.mobile1 || banners.desktop1}"
              >
              <img src="${banners.desktop1}" alt="">
            </picture>
          `
              : ""
          }

          ${
            banners.desktop2
              ? `
            <picture class="bundle-custom-banner">
              <source
                media="(max-width:989px)"
                srcset="${banners.mobile2 || banners.desktop2}"
              >
              <img src="${banners.desktop2}" alt="">
            </picture>
          `
              : ""
          }

        </div>
      `;

      defaultBanner.insertAdjacentHTML("beforebegin", html);
      defaultBanner.style.display = "none";

      if (!document.getElementById("bundle-banner-styles")) {
        const style = document.createElement("style");
        style.id = "bundle-banner-styles";

        style.textContent = `
        .bundle-custom-banner {
          position: relative;
        }

        .bundle-custom-banner .gbbCategoryContainer {
          position: absolute;
          left: 50%;
          bottom: 20px;
          transform: translateX(-50%);
          z-index: 20;
          width: auto;
        }

        .bundle-custom-banner .gbbCategoryHeaderContainer {
          cursor: pointer;
        }

        .bundle-custom-banners .gbbMultipleCategoriesRibbonContainer {
          display: contents !important;
        }

        body.bundle-custom-banners-active .gbbMultipleCategoriesRibbonContainer,
        body.bundle-custom-banners-active .gbbMultipleCategoriesDropdownContainer {
          display: none !important;
        }

 .bundle-custom-banner .gbbCategoryHeaderContainer {
  background: #fff;
}

.gbbCategoryContainer{
border: none !important;
}
.bundle-custom-banner
.gbbCategoryContainerTabUIActive
.gbbCategoryHeaderContainer {
  background: #000 !important;
}

.bundle-custom-banner
.gbbCategoryContainerTabUIActive
.gbbCategoryTitle {
  color: #fff !important;
}

.bundle-custom-banner
.gbbCategoryContainer:not(.gbbCategoryContainerTabUIActive)
.gbbCategoryTitle {
  color: #000 !important;
}

.bundle-custom-banner {
  opacity: 0.6;
  transition: opacity .25s ease;
}

.bundle-custom-banner:first-child {
  opacity: 1;
}
      `;

        document.head.appendChild(style);
      }

      if (
        banners.show_different_banners &&
        (banners.desktop1 || banners.desktop2)
      ) {
        document.body.classList.add("bundle-custom-banners-active");
      } else {
        document.body.classList.remove("bundle-custom-banners-active");
      }

      const ribbon = document.querySelector(
        ".gbbMultipleCategoriesRibbonContainer",
      );
      const dropdown = document.querySelector(
        ".gbbMultipleCategoriesDropdownContainer",
      );

      if (
        banners.show_different_tabs &&
        ribbon &&
        !ribbon.dataset.bannerMoved
      ) {
        ribbon.dataset.bannerMoved = "true";

        const categories = ribbon.querySelectorAll(".gbbCategoryContainer");
        const bannerEls = document.querySelectorAll(".bundle-custom-banner");

        categories.forEach((category, index) => {
          if (bannerEls[index]) {
            bannerEls[index].appendChild(category);
          }
        });

        bannerEls.forEach((banner) => {
          if (banner.dataset.clickBound) return;
          banner.dataset.clickBound = "true";

          banner.style.cursor = "pointer";

          banner.addEventListener("click", (e) => {
            // Ignore clicks on the actual button
            if (e.target.closest(".gbbCategoryContainer")) return;

            const header = banner.querySelector(".gbbCategoryHeaderContainer");

            if (header) {
              header.click();
            }
          });
        });
      }

      if (ribbon) {
        if (banners.show_different_tabs) {
          ribbon.style.setProperty("display", "none", "important");
        } else {
          ribbon.style.setProperty("display", "", "");
        }
      }

      if (dropdown) {
        if (banners.show_different_tabs) {
          dropdown.style.setProperty("display", "none", "important");
        } else {
          dropdown.style.setProperty("display", "", "");
        }
      }

      function syncCustomBannerButtons() {
        document
          .querySelectorAll(".bundle-custom-banner .gbbCategoryContainer")
          .forEach((btn) => {
            const id = btn.getAttribute("categoryid");

            // ORIGINAL hidden ribbon button
            const original = Array.from(
              document.querySelectorAll(
                ".gbbMultipleCategoriesRibbonContainer .gbbCategoryContainer",
              ),
            ).find((el) => el.getAttribute("categoryid") === id);

            if (!original) return;

            const active = original.style.background.includes("0, 0, 0");

            const header = btn.querySelector(".gbbCategoryHeaderContainer");

            const title = btn.querySelector(".gbbCategoryTitle");

            const banner = btn.closest(".bundle-custom-banner");

            if (banner) {
              banner.style.setProperty(
                "opacity",
                active ? "1" : "0.6",
                "important",
              );
            }

            btn.style.setProperty(
              "background",
              active ? "#000" : "#fff",
              "important",
            );

            btn.style.setProperty(
              "color",
              active ? "#fff" : "#000",
              "important",
            );

            if (header) {
              header.style.setProperty(
                "background",
                active ? "#000" : "#fff",
                "important",
              );

              header.style.setProperty(
                "color",
                active ? "#fff" : "#000",
                "important",
              );
            }

            if (title) {
              title.style.setProperty(
                "color",
                active ? "#fff" : "#000",
                "important",
              );
            }
          });
      }

      syncCustomBannerButtons();

      document.addEventListener("click", (e) => {
        if (e.target.closest(".gbbCategoryContainer")) {
          setTimeout(syncCustomBannerButtons, 100);
        }
      });

      syncCustomBannerButtons();

      const observer = new MutationObserver(() => {
        syncCustomBannerButtons();
      });

      document.querySelectorAll(".gbbCategoryContainer").forEach((el) => {
        observer.observe(el, {
          attributes: true,
          attributeFilter: ["class"],
        });
      });

      document.addEventListener("click", (e) => {
        if (e.target.closest(".gbbCategoryContainer")) {
          setTimeout(syncCustomBannerButtons, 100);
        }
      });

      syncCustomBannerButtons();
      if (!window.bundleCategoryObserver) {
        window.bundleCategoryObserver = new MutationObserver(() => {
          requestAnimationFrame(syncCustomBannerButtons);
        });

        document.querySelectorAll(".gbbCategoryContainer").forEach((el) => {
          window.bundleCategoryObserver.observe(el, {
            attributes: true,
            attributeFilter: ["class", "style"],
          });
        });
      }

      return true;
    }

    if (tryInject()) return;

    const observer = new MutationObserver(function (mutations, obs) {
      if (tryInject()) {
        obs.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  }
  // ── Init ───────────────────────────────────────────────────
  function init() {
    let syncTimer = null;

    function throttledSync() {
      if (syncTimer) return;
      syncTimer = setTimeout(() => {
        syncTimer = null;
        clearButtonText();
        injectDiscountTags();
        convertSelectToTabs();
        const footer = getFooter();
        if (footer && !window.bundleAppShowcasingPrices) syncStepperState();
      }, 150);
    }

    function moveSizeChartLink() {
      const modal = document.querySelector(
        ".gbbProductVariantModalMainContainer",
      );
      if (!modal) return;

      const link = modal.querySelector(".bundle-size-chart-link");

      const sizeContainer = modal.querySelector(
        '.gbbProductVariantOptionContainer[optionid="Size"]',
      );

      const label = sizeContainer?.querySelector(
        ".gbbProductVariantOptionLabel",
      );

      const values = sizeContainer?.querySelector(
        ".gbbProductVariantOptionValuesContainer",
      );

      if (!link || !sizeContainer || !label || !values) return;

      // Already moved
      if (sizeContainer.contains(link)) return;

      // Move link directly into Size container
      sizeContainer.insertBefore(link, values);
    }

    const observer = new MutationObserver(() => {
      injectCustomBundleBanners();
      convertSelectToTabs();
      injectSizeChart();
      if (window.bundleAppShowcasingPrices) return;

      const footer = getFooter();
      if (!footer) return;

      throttledSync();

      const first = footer.childNodes[0];
      if (first?.nodeType === 3 && first.textContent.trim())
        first.textContent = "";

      initStickyFooter();
      moveSizeChartLink();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      clearButtonText();
      syncStepperState();
      initStickyFooter();
      injectSizeChart();
      injectCustomBundleBanners();
    }, 100);

    document.addEventListener("click", handleStepperClick);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
